<template>
  <div class="bbp-reminder-panel-body-users">
    <div
      v-for="user in users"
      :key="user._id"
      :class="[
        'bbp-reminder-panel-body-users__image',
        !user.image && 'bbp-reminder-panel-body-users__image_default'
      ]"
    >
      <img :src="getUserImage(user)" alt="">
    </div>
  </div>
</template>

<script>
import avatarUserDefault from '@/assets/images/avatar-user-default.png'
import {get} from 'lodash'

export default {
  name: 'BBPReminderPanelBodyUsers',
  props: {
    users: {
      type: Array,
      default: () => ([])
    }
  },
  methods: {
    getUserImage (user) {
      return get(user, 'image.path', avatarUserDefault)
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../../../../sass/variables";

  .bbp-reminder-panel-body-users {
    display: flex;
    margin: -2px 0 -3px -2px;

    &__image {
      width: 25px;
      height: 25px;
      border-radius: 50%;
      overflow: hidden;
      box-sizing: content-box;
      border: 2px solid $color-white;

      & + & {
        margin: 0 0 0 -11px;
      }

      &_default {
        width: 27px;
        height: 27px;
        border: 1px solid $color-white;
      }

      img {
        width: 100%;
        height: 100%;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Main/BBPTable/BBPReminder/BBPReminderPanel/BBPReminderPanelBody/BBPReminderPanelBodyUsers.vue